module.exports = __webpack_public_path__ + "static/media/Poppins-Light.37eeb65c.ttf";